import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loadpage',
  templateUrl: './loadpage.component.html',
  styleUrls: ['./loadpage.component.scss']
})
export class LoadpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
